// Export markers should look like section breaks in a scrolling preview.
// Leave fenced code examples intact, even when they contain the same marker.
export function documentPreviewMarkdown(markdown) {
  let fence = null;
  return String(markdown || '').split('\n').map(line => {
    const delimiter = line.match(/^ {0,3}(`{3,}|~{3,})(.*)$/);
    if (delimiter) {
      if (!fence) fence = delimiter[1];
      else if (delimiter[1][0] === fence[0] && delimiter[1].length >= fence.length && !delimiter[2].trim()) fence = null;
      return line;
    }
    return !fence && /^ {0,3}<!--\s*pagebreak\s*-->\s*$/i.test(line) ? '\n---\n' : line;
  }).join('\n');
}
